import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar: React.FC = () => {
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);

    const closeSidebar = () => {
        const windowWidth = window.innerWidth;
        const body = document.body;

        if (windowWidth < 992) {
            body.classList.remove("sidebar-open");
            body.classList.add("sidebar-close");
        }
    };

    const toggleDropdown = (e: React.MouseEvent, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenDropdown(prev => prev === id ? null : id);
    };

    return (
        <div className="adminuiux-sidebar">
            <div className="adminuiux-sidebar-inner">
                <div className="p-3">
                    <div className="input-group input-group-md rounded">
                        <span className="input-group-text">
                            <i className="bi bi-briefcase"></i>
                        </span>
                        <select className="form-select" aria-label="Default select example" defaultValue="All">
                            <option value="All">All</option>
                            <option value="1">Business</option>
                            <option value="2">Personal</option>
                            <option value="3">Family</option>
                        </select>
                    </div>
                </div>

                {/* user menu navigation */}
                <ul className="nav flex-column menu-active-line">
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/app/dashboard" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-house-door"></i>
                            <div className="col menu-name">Home</div>
                        </NavLink>
                    </li>


                    <li className="nav-item">
                        <NavLink className="nav-link" to="/app/job-portal" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-briefcase"></i>
                            <div className="col align-self-center menu-name">Job Portal</div>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/app/restaurant" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-fork-knife"></i>
                            <div className="col align-self-center menu-name">Restaurant</div>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/app/finance-dashboard" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-speedometer2"></i>
                            <div className="col align-self-center menu-name">Finance Dashboard</div>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/app/social-dashboard" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-bullseye"></i>
                            <div className="col align-self-center menu-name">Social Dashboard</div>
                        </NavLink>
                    </li>

                    {/* personalize */}
                    <li className="nav-item">
                        <NavLink to="/app/personalization" className="nav-link" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-palette h4"></i>
                            <span className="menu-name">Personalize <small className="fs-12">❤️</small></span>
                        </NavLink>
                    </li>
                </ul>

                {/* user secondary menu navigation */}
                <div className="px-3 not-iconic">
                    <h6>Pages</h6>
                </div>
                <ul className="nav flex-column menu-active-line">
                    {/* applications */}
                    <li className="nav-item dropdown">
                        <a className={`nav-link dropdown-toggle ${openDropdown === 'applications' ? 'show' : ''}`} role="button" onClick={(e) => toggleDropdown(e, 'applications')}>
                            <i className="menu-icon bi bi-window-dock"></i>
                            <div className="col menu-name">Applications</div>
                        </a>
                        <ul className={`dropdown-menu ${openDropdown === 'applications' ? 'show' : ''}`}>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/chat-message" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-chat"></i>
                                    <div className="col menu-name">Chat</div>
                                    <div className="col-auto not-iconic">
                                        <i className="bi bi-calendar-event fs-10 vm text-white avatar avatar-20 rounded-circle bg-theme-1 text-center "></i>
                                    </div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/email" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-envelope"></i>
                                    <div className="col menu-name">Email</div>
                                    <div className="col-auto align-self-center not-iconic">
                                        <figure className="avatar avatar-20 coverimg rounded-circle">
                                            <img src={asset('/assets/img/adminuiux/user-2.jpg')} alt="" />
                                        </figure>
                                        <figure className="avatar avatar-20 coverimg rounded-circle">
                                            <img src={asset('/assets/img/adminuiux/user-8.jpg')} alt="" />
                                        </figure>
                                        <figure className="avatar avatar-20 bg-theme-1-subtle rounded-circle">
                                            <small className="fs-10 vm">9+</small>
                                        </figure>
                                    </div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/explorer" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-folder position-relative">
                                        <span className="position-absolute top-0 end-100 p-1 bg-danger border border-light rounded-circle">
                                            <span className="visually-hidden">New alerts</span>
                                        </span>
                                    </i>
                                    <div className="col menu-name">Explorer</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/calendar" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-calendar-event"></i>
                                    <div className="col menu-name">Calendar</div>
                                    <div className="col-auto not-iconic">
                                        <i className="bi bi-calendar-event fs-10 vm text-white avatar avatar-20 rounded-circle bg-theme-1 text-center "></i>
                                    </div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    {/* company */}
                    <li className="nav-item dropdown">
                        <a className={`nav-link dropdown-toggle ${openDropdown === 'company' ? 'show' : ''}`} role="button" onClick={(e) => toggleDropdown(e, 'company')}>
                            <i className="menu-icon bi bi-building"></i>
                            <div className="col menu-name">Company</div>
                        </a>
                        <ul className={`dropdown-menu ${openDropdown === 'company' ? 'show' : ''}`}>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/company-profile" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-easel2"></i>
                                    <div className="col align-self-center menu-name">Company Profile</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/company-career" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-file-earmark-person"></i>
                                    <div className="col align-self-center menu-name">Career</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/company-help-center" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-life-preserver"></i>
                                    <div className="col align-self-center menu-name">Help Center</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/company-contact-us" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-envelope"></i>
                                    <div className="col align-self-center menu-name">Contact us</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    {/* forum */}
                    <li className="nav-item dropdown">
                        <a className={`nav-link dropdown-toggle ${openDropdown === 'forum' ? 'show' : ''}`} role="button" onClick={(e) => toggleDropdown(e, 'forum')}>
                            <i className="menu-icon bi bi-question-circle"></i>
                            <div className="col menu-name">Forum</div>
                        </a>
                        <ul className={`dropdown-menu ${openDropdown === 'forum' ? 'show' : ''}`}>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/forum" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-question-circle"></i>
                                    <div className="col align-self-center menu-name">Forum</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/forum-details" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-people"></i>
                                    <div className="col align-self-center menu-name">Forum Details</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    {/* Profile Dropdown */}
                    <li className="nav-item dropdown">
                        <a className={`nav-link dropdown-toggle ${openDropdown === 'profile' ? 'show' : ''}`} role="button" onClick={(e) => toggleDropdown(e, 'profile')}>
                            <i className="menu-icon bi bi-person-circle"></i>
                            <div className="col menu-name">Profile</div>
                        </a>
                        <ul className={`dropdown-menu ${openDropdown === 'profile' ? 'show' : ''}`}>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/my-profile" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-briefcase"></i>
                                    <div className="col align-self-center menu-name">My Profile</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/earning" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-cash-stack"></i>
                                    <div className="col align-self-center menu-name">Earning</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/subscription" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-gift"></i>
                                    <div className="col align-self-center menu-name">Subscription</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/subscription-plan" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-box-seam"></i>
                                    <div className="col align-self-center menu-name">Plans</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/statement" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-clipboard-check"></i>
                                    <div className="col align-self-center menu-name">Statement</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/app/account-settings" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-gear"></i>
                                    <div className="col align-self-center menu-name">Settings</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    {/* Supportive Pages Dropdown */}
                    <li className="nav-item dropdown">
                        <a className={`nav-link dropdown-toggle ${openDropdown === 'supportive' ? 'show' : ''}`} role="button" onClick={(e) => toggleDropdown(e, 'supportive')}>
                            <i className="menu-icon bi bi-window-stack"></i>
                            <div className="col menu-name">Supportive Pages</div>
                        </a>
                        <ul className={`dropdown-menu ${openDropdown === 'supportive' ? 'show' : ''}`}>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/auth/login" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-person"></i>
                                    <div className="col align-self-center menu-name">Sign in</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/auth/signup" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-person-plus"></i>
                                    <div className="col align-self-center menu-name">Sign up</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/auth/forgot-password" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-key"></i>
                                    <div className="col align-self-center menu-name">Forgot Password</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/auth/change-password" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-key"></i>
                                    <div className="col align-self-center menu-name">Change Password</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/auth/signup-success" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-person"></i>
                                    <div className="col align-self-center menu-name">Sign up success</div>
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink className="nav-link" to="/auth/onboarding" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-stopwatch"></i>
                                    <div className="col align-self-center menu-name">Onboarding</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    {/* Extras Dropdown */}
                    <li className="nav-item dropdown">
                        <a className={`nav-link dropdown-toggle ${openDropdown === 'extras' ? 'show' : ''}`} role="button" onClick={(e) => toggleDropdown(e, 'extras')}>
                            <i className="menu-icon bi bi-stars"></i>
                            <div className="col menu-name">Extras</div>
                        </a>
                        <ul className={`dropdown-menu ${openDropdown === 'extras' ? 'show' : ''}`}>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/extras/coming-soon" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-hourglass-split"></i>
                                    <div className="col align-self-center menu-name">Coming Soon</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/extras/maintenance" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-tools"></i>
                                    <div className="col align-self-center menu-name">Maintenance</div>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/extras/404" onClick={closeSidebar}>
                                    <i className="menu-icon bi bi-exclamation-triangle"></i>
                                    <div className="col align-self-center menu-name">404 Page</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                </ul>

                <div className=" mt-auto "></div>

                <ul className="nav flex-column menu-active-line mb-2">
                    <li className="nav-item">
                        <NavLink className="nav-link" to="/app/account-settings" onClick={closeSidebar}>
                            <i className="menu-icon bi bi-cpu"></i>
                            <span className="menu-name">Account Settings</span>
                        </NavLink>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;
